import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhyArdaComponent } from './why-arda.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [WhyArdaComponent],
  exports: [WhyArdaComponent]
})
export class WhyArdaModule { }



// WEBPACK FOOTER //
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/why-arda/why-arda.module.ts